import shaka from "../static/icons/shaka_svg.svg"

function Loader() {

    return(
        <div className="flex flex-col align-center loader items-center bg-white p-3 shadow-lg rounded-lg m-4 block">
            <object data={shaka} aria-label="shaka icon" alt="shaka" className="pulse" />
            <p className="mt-2">Loading...</p>
        </div>
    )
}

export default Loader;